import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download\">\r\n<path d=\"M2 9.33337L2.1559 9.77508C2.76267 11.4943 3.06605 12.3539 3.75828 12.8436C4.45051 13.3334 5.36206 13.3334 7.18518 13.3334H8.81482C10.6379 13.3334 11.5495 13.3334 12.2417 12.8436C12.934 12.3539 13.2373 11.4943 13.8441 9.77508L14 9.33337\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\r\n<path d=\"M8.00065 9.33341V2.66675M8.00065 9.33341C7.53383 9.33341 6.66167 8.00388 6.33398 7.66675M8.00065 9.33341C8.46747 9.33341 9.33963 8.00388 9.66732 7.66675\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download.svg
// module id = +H2/
// module chunks = 36